"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.receiveFolderDelete = receiveFolderDelete;
exports.receiveRenameFolder = receiveRenameFolder;
exports.addFolder = addFolder;

var _I18n = _interopRequireDefault(require("I18n"));

var ActionTypes = _interopRequireWildcard(require("./ActionTypes"));

var _Folders = require("../api/Folders");

var _tracking = require("./tracking");

function receiveFolderDelete(folder) {
  return {
    type: ActionTypes.DELETE_FOLDER_SUCCEEDED,
    folder: folder
  };
}

function receiveRenameFolder(folder) {
  return {
    type: ActionTypes.RENAME_FOLDER_SUCCEEDED,
    folder: folder
  };
}

function receiveAddFolder(folder) {
  return {
    type: ActionTypes.ADD_FOLDER_SUCCEEDED,
    meta: Object.assign({}, (0, _tracking.getTrackingMeta)('fileManagerManageFolders', 'create new folder'), {
      notification: {
        type: 'success',
        titleText: _I18n.default.text('FileManagerCore.notifications.addFolder.success.title'),
        message: _I18n.default.text('FileManagerCore.notifications.addFolder.success.message', {
          folder: folder.get('name')
        })
      }
    }),
    folder: folder
  };
}

function addFolder(_ref) {
  var parentId = _ref.parentId,
      name = _ref.name;
  return function (dispatch, getState, httpClient) {
    (0, _Folders.add)({
      parentId: parentId,
      name: name
    }, httpClient).then(function (data) {
      dispatch(receiveAddFolder(data));
    }, function (error) {
      dispatch({
        type: ActionTypes.ADD_FOLDER_FAILED,
        meta: {
          notification: {
            type: 'danger',
            titleText: _I18n.default.text('FileManagerCore.notifications.addFolder.error.title'),
            message: _I18n.default.text('FileManagerCore.notifications.addFolder.error.message', {
              folder: name
            })
          }
        },
        error: error
      });
    }).done();
  };
}